"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryEnterprise = arbitraryEnterprise;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const handle_1 = require("../../src/handle");
const identifier_1 = require("../../src/identifier");
const workspace_1 = require("../../src/workspace");
const identifier_2 = require("./identifier");
function arbitraryEnterprise(constraints = {}) {
    if (constraints.defaultOrganization && !constraints.defaultOrganization.enterpriseUid) {
        throw new Error("Expected the defaultOrganization constraint to have an enterpriseUid");
    }
    const uid = constraints?.enterpriseUid
        ? fast_check_1.default.constant(constraints.enterpriseUid)
        : constraints?.defaultOrganization?.enterpriseUid
            ? fast_check_1.default.constant(constraints.defaultOrganization.enterpriseUid)
            : fast_check_1.default.uuid().map((i) => identifier_1.EnterpriseUid.parse(`ent_${i}`));
    const defaultOrganizationUid = constraints.defaultOrganization
        ? fast_check_1.default.constant(constraints.defaultOrganization.uid)
        : identifier_2.arbitraryOrganizationUid;
    const handle = handle_1.EnterpriseHandle.safeParse(constraints.defaultOrganization?.handle)?.success
        ? fast_check_1.default.constant(handle_1.EnterpriseHandle.parse(constraints.defaultOrganization?.handle))
        : fast_check_1.default.hexaString({ minLength: 3 }).map((s) => handle_1.EnterpriseHandle.parse(`ent${s}`));
    return fast_check_1.default.record({
        uid,
        displayName: fast_check_1.default.string(),
        handle,
        visibility: fast_check_1.default.constant(constraints?.visibility ?? workspace_1.EnterpriseVisibility.Values.private),
        isTest: fast_check_1.default.constant(true),
        defaultOrganizationUid,
        createdAt: fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }).map((date) => date.getTime()),
        updatedAt: fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }).map((date) => date.getTime()),
    });
}
//# sourceMappingURL=enterprise.js.map